module.exports = __webpack_public_path__ + "3931fd1547ff45a4cf92cafcc3e17ab3.woff2";